var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('idle-component'),_c('nav-bar-component',{attrs:{"role":_vm.useCurrentContextStore.getRole,"username":_vm.useCurrentContextStore.getUsername,"organisatie-naam":_vm.useCurrentContextStore.getOrganisatieNaam}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }